<template>
  <transition name="fade">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Forgotten Password</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" @click="close">&times;</span>
              </button>
            </div>
            <div class="modal-body rounded shadow bg-light">
              <div class="col-12">
                <p>If you need help reseting your password, we can help by sending you a link to reset it.</p>
                <p>Please complete the following steps:</p>
                <ul>
                  <li>Enter the email address on your Corpuls account</li>
                  <li>
                    Select
                    <b>Send Me A Password Reset Link</b>
                  </li>
                  <li>Check your inbox for a password reset email</li>
                  <li>Click on the URL included inside the email and follow the instructions on screen</li>
                </ul>
                <div class="alert alert-success" v-if="passwordSent">
                  <strong>Success!</strong> If we found an account registered to that address, we have sent you an email with further instructions.
                </div>
                <form @submit.prevent="requestPasswordReset">
                  <div class="form-group">
                    <div id="auth-messages" class="auth-messages"></div>
                    <label for="exampleInputEmail1">Email address</label>
                    <input
                      type="email"
                      class="form-control"
                      id="inputEmailModal"
                      aria-describedby="emailHelp"
                      placeholder="Enter email"
                    />
                    <small
                      id="emailHelp"
                      class="form-text text-muted"
                    >We'll never share your email with anyone else.</small>
                  </div>
                  <div class="modal-footer">
                    <button
                      id="sendButton"
                      type="submit"
                      class="btn btn-primary"
                    >Send Me A Password Reset Link</button>
                    <button type="button" class="btn btn-secondary" @click="close">Close</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import UserService from "../services/user.service";
export default {
  name: "ForgotPasswordModal",

  data() {
    return {
      passwordSent: false,
      errorFound: false,
      loading: false
    };
  },

  methods: {
    close() {
      this.$emit("close");
    },
    requestPasswordReset: function() {
      this.loading = false;
      this.passwordSent = false;
      let userName = document.getElementById("inputEmailModal").value;
      UserService.requestPasswordReset(userName)
        .then(() => {
          this.passwordSent = true;
        })
        .catch(() => {
          this.passwordSent = false;
        })
        .finally(() => {});
    }
  }
};
</script>

<style>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  border-bottom: 1px solid #eeeeee;
  color: #007bff;
  justify-content: space-between;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
  justify-content: flex-end;
}

.modal-body {
  position: relative;
  padding: 20px 10px;
  text-align: left;
}

.btn-close {
  border: none;
  font-size: 20px;
  padding: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #4aae9b;
  background: transparent;
}

.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}

.modal-wrapper{
      position: absolute;
    bottom: 15%;
    right: 0;
    left: 0;
}
</style>